import { pipe } from 'ramda';
import { TLD } from '@core/app-config';
import { isBrowser } from '@core/browser/identify';
import { isRouteSegmentLocale } from '@core/internationalize/models/path';
import { LOCALE_TOGGLE } from '@core/internationalize/models/toggle';

export enum Store {
  UnitedStates = 'dotcom',
  UnitedKingdom = 'webstore_gb',
  Canada = 'ca_webstore',
  Germany = 'de_webstore',
  Default = UnitedStates,
  Australia = 'au_webstore',
  Austria = 'at_webstore',
}

const tldStoresMap: Record<string, Store> = {
  '.com': Store.UnitedStates,
  '.co.uk': Store.UnitedKingdom,
  '.ca': Store.Canada,
  '.de': Store.Germany,
  'com.au': Store.Australia,
  '.at': Store.Austria,
};

export const localeStoresMap: Record<string, Store> = {
  us: Store.UnitedStates,
  gb: Store.UnitedKingdom,
  ca: Store.Canada,
  de: Store.Germany,
  au: Store.Australia,
  at: Store.Austria,
};

export const toStore = (hostname: string = TLD ?? window.location.hostname): Store => {
  if (
    isBrowser &&
    LOCALE_TOGGLE &&
    isRouteSegmentLocale(window.location.pathname.split('/')[1])
  ) {
    const locale = window.location.pathname.split('/')[1].split('-')[1].toLowerCase();
    return localeStoresMap[locale] || Store.Default;
  }
  const key = Object.keys(tldStoresMap).find(tld => hostname.endsWith(tld));
  return (key && tldStoresMap[key]) || Store.Default;
};
export type WebStore = {
  kind: 'web';
  slug: Store;
};

// Need to annotate because pipe does not support optional first param in initial fn.
const toWebStore: (hostname?: string) => WebStore = pipe<string, Store, WebStore>(
  toStore,
  (slug: Store): WebStore => ({
    kind: 'web',
    slug,
  }),
);

export { toWebStore };
